import { ColorDynamic, Inline } from '@superdispatch/ui';
import { TextBox } from '@superdispatch/ui-lab';
import { useMemo } from 'react';
import { VehicleConditionIcon } from 'shared/ui/VehicleConditionIcon';
import styled from 'styled-components';
import {
  PostingLoadDTO,
  PostingTransportType,
} from '../../data/dto/PostingLoadDTO';

const Wrapper = styled.div<{
  hasInoperable?: boolean;
  transportType?: PostingTransportType;
}>`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 44px;
  margin: 0 -16px;

  background-color: ${({ hasInoperable, transportType }) =>
    hasInoperable
      ? ColorDynamic.Red50
      : transportType === 'ENCLOSED'
        ? ColorDynamic.Yellow50
        : transportType === 'DRIVEAWAY'
          ? ColorDynamic.Purple50
          : 'auto'};
`;

function formatTransportType(
  transportType: PostingTransportType,
  hasInoperable: boolean,
) {
  return transportType === 'ENCLOSED' && hasInoperable
    ? 'Inoperable and Enclosed Trailer'
    : transportType === 'DRIVEAWAY' && hasInoperable
      ? 'Inoperable and Driveaway'
      : transportType === 'ENCLOSED'
        ? 'Enclosed Trailer Required'
        : transportType === 'DRIVEAWAY'
          ? 'Driveaway'
          : hasInoperable
            ? 'Inoperable Vehicle'
            : null;
}

export function PostingVehicleStatus({ load }: { load: PostingLoadDTO }) {
  const hasInoperable = useMemo(
    () => load.vehicles.some(({ is_inoperable }) => is_inoperable),
    [load.vehicles],
  );

  if (load.transport_type === 'OPEN' && !hasInoperable) {
    return null;
  }

  return (
    <Wrapper hasInoperable={hasInoperable} transportType={load.transport_type}>
      <Inline space="xsmall" verticalAlign="center">
        <VehicleConditionIcon
          isInoperable={hasInoperable}
          transportType={load.transport_type}
        />

        <TextBox>
          {formatTransportType(load.transport_type, hasInoperable)}
        </TextBox>
      </Inline>
    </Wrapper>
  );
}
